<div class="">
     <app-side-navbar></app-side-navbar>
</div>
<app-proxy-label></app-proxy-label>
<div class="app-vertical-line"></div>
<app-chat-popup></app-chat-popup>
